import React, { Component } from "react";
import ExpTypeList from "./ExpenseTypeList";
import ExpTypeAddEdit from "./ExpenseTypeAddEdit";

class ExpType extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: "List",
      data: null
    };
    this.handleClick = this.handleClick.bind(this);
  }
  render() {
    if (this.state.mode === "List") {
      return <ExpTypeList onClick={this.handleClick} />;
    } else {
      return (
        <ExpTypeAddEdit
          pData={this.state.data}
          onClick={this.handleClick}
          source="list"
        />
      );
    }
  }

  handleClick(mode, data) {
    this.setState({ data, mode });
  }
}

export default ExpType;
